import { HttpParams } from '@angular/common/http';

export class UrlUtility {
  static GetQueryStringValue(paramName: string): string {
    const url = window.location.href;
    let paramValue: string;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }
}
